<template>
  <div>
    <div class="web4">
      <div class="outterBox">
        <div class="topHeader">
          {{ getListType }} 내역 <span class="numText">{{ totalCount }}</span> <span class="countText"> 건</span>
        </div>
        <div class="top">
          <div class="dateColumn">
            <div class="select-list-form border p-3 tablePadding">
              <div v-if="revConfirmList.length > 0" class="text-center">
                <div class="table-responsive mb-0 bg-white">
                  <table class="table table-center table-nowrap bordered tableStyle">
                    <thead>
                      <tr>
                        <th class="col-lg-1 col-1" scope="col">이용일자</th>
                        <template v-if="listType === 'REAL'">
                          <th class="col-lg-1 col-1" scope="col">코스</th>
                        </template>
                        <th class="col-lg-1 col-1" scope="col">홀 수</th>
                        <th class="col-lg-1 col-1" scope="col">티오프</th>
                        <th class="col-lg-1 col-1" scope="col">팀 수</th>
                        <th class="col-lg-1 col-1" scope="col">변경</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(o, i) in revConfirmList" :key="i">
                        <td>{{ getDateString(o.selectedDate) }}</td>
                        <td v-if="listType === 'REAL'">
                          {{ o.selectedCourse.coseName }}
                        </td>

                        <td v-if="listType !== 'REAL'">{{ getCourseHoleString(o.selectedCourse.coseCd) }}홀</td>
                        <td v-if="listType === 'REAL'">{{ getCourseHoleString(o.selectedRealTeeOff.rndCd) }}홀</td>

                        <td v-if="listType !== 'REAL'">{{ o.selectedTeeOff.detailName }}</td>
                        <td v-if="listType === 'REAL'">{{ o.selectedRealTeeOff.time | toTime }}</td>

                        <td v-if="isCompany(o) && listType !== 'REAL'">
                          <b-form-spinbutton
                            inline
                            v-model="o.teamCount"
                            min="1"
                            :max="getMaxCount(o)"
                            @change="refreshTotalCount"
                          ></b-form-spinbutton>
                        </td>
                        <td v-else>{{ o.teamCount }}</td>
                        <td>
                          <button class="deleteButton" @click="onItemClickDelete(o, i)"><span>삭제</span></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else class="noItem">
                <span>등록된 접수가 없습니다.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile4">
      <div class="outterBox">
        <div class="topHeader">
          {{ getListType }} 내역 <span class="numText">{{ totalCount }}</span> <span class="countText"> 건</span>
        </div>
        <div class="top">
          <div class="dateColumn">
            <div class="select-list-form mb-1">
              <div v-if="revConfirmList.length > 0" class="text-center">
                <div class="itemStyle" v-for="(item, index) in revConfirmList" :key="index">
                  <div class="rowSpace"></div>
                  <div class="row justify-content-center">
                    <div class="cHead col-4">이용일자</div>
                    <div class="cBody col-8">{{ getDateString(item.selectedDate) }}</div>
                  </div>
                  <div class="row" v-if="listType === 'REAL'">
                    <div class="cHead col-4">코스</div>
                    <div class="cBody col-8">{{ item.selectedCourse.coseName }}</div>
                  </div>
                  <div class="row">
                    <div class="cHead col-4">홀 수</div>
                    <div class="cBody col-8" v-if="listType !== 'REAL'">
                      {{ getCourseHoleString(item.selectedCourse.coseCd) }}홀
                    </div>
                    <div class="cBody col-8" v-if="listType === 'REAL'">
                      {{ getCourseHoleString(item.selectedRealTeeOff.rndCd) }}홀
                    </div>
                  </div>
                  <div class="row">
                    <div class="cHead col-4">티오프</div>
                    <div class="cBody col-8" v-if="listType !== 'REAL'">{{ item.selectedTeeOff.detailName }}</div>
                    <div class="cBody col-8" v-if="listType === 'REAL'">
                      {{ item.selectedRealTeeOff.time | toTime }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="cHead col-4">팀 수</div>
                    <div class="cBody col-8" v-if="isCompany(item) && listType !== 'REAL'">
                      <b-form-spinbutton
                        class="spinStyle"
                        inline
                        v-model="item.teamCount"
                        min="1"
                        :max="getMaxCount(item)"
                        @change="refreshTotalCount"
                      ></b-form-spinbutton>
                    </div>
                    <div class="cBody col-8" v-else>{{ item.teamCount }}</div>
                  </div>
                  <div class="rowSpace"></div>
                  <hr />
                  <div class="row">
                    <div class="col-12">
                      <button class="deleteButton" @click="onItemClickDelete(item, index)"><span>삭제</span></button>
                    </div>
                  </div>
                </div>

                <!--                <div>-->
                <!--                  이전-->
                <!--                  <table>-->
                <!--                    <tr>-->
                <!--                      <th class="col-lg-1 col-1" scope="col">이용일자</th>-->
                <!--                      <template v-if="listType === 'REAL'">-->
                <!--                        <th class="col-lg-1 col-1" scope="col">코스</th>-->
                <!--                      </template>-->
                <!--                      <th class="col-lg-1 col-1" scope="col">홀 수</th>-->
                <!--                      <th class="col-lg-1 col-1" scope="col">티오프</th>-->
                <!--                      <th class="col-lg-1 col-1" scope="col">팀 수</th>-->
                <!--                      <th class="col-lg-1 col-1" scope="col">변경</th>-->
                <!--                    </tr>-->
                <!--                  </table>-->

                <!--                  <table>-->
                <!--                    <tr v-for="(o, i) in revConfirmList" :key="i">-->
                <!--                      <td>{{ getDateString(o.selectedDate) }}</td>-->
                <!--                      <td v-if="listType === 'REAL'">+</td>-->

                <!--                      <td v-if="listType !== 'REAL'">{{ getCourseHoleString(o.selectedCourse.coseCd) }}</td>-->
                <!--                      <td v-if="listType === 'REAL'">{{ getCourseHoleString(o.selectedRealTeeOff.rndCd) }}</td>-->

                <!--                      <td v-if="listType !== 'REAL'">{{ o.selectedTeeOff.detailName }}</td>-->
                <!--                      <td v-if="listType === 'REAL'">{{ o.selectedRealTeeOff.time | toTime }}</td>-->

                <!--                      <td v-if="isCompany(o) && listType !== 'REAL'">-->
                <!--                        <b-form-spinbutton-->
                <!--                          inline-->
                <!--                          v-model="o.teamCount"-->
                <!--                          min="1"-->
                <!--                          :max="getMaxCount(o)"-->
                <!--                          @change="refreshTotalCount"-->
                <!--                        ></b-form-spinbutton>-->
                <!--                      </td>-->
                <!--                      <td v-else>{{ o.teamCount }}</td>-->
                <!--                      <td>-->
                <!--                        <button class="deleteButton" @click="onItemClickDelete(o, i)"><span>삭제</span></button>-->
                <!--                      </td>-->
                <!--                    </tr>-->
                <!--                  </table>-->
                <!--                </div>-->
              </div>

              <div v-else class="noItem">
                <span>등록된 접수가 없습니다.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import reserveService from '@/services/rev.service';
import {getReservText} from '@/util/GolfUtil';
import {DateUtil} from '@/util/DateUtil';

export default {
  name: 'ReceiptList',
  props: {
    listType: String,
    revConfirmList: Array,
  },

  watch: {
    revConfirmList(newVal, oldVal) {
      this.refreshTotalCount();
    },
  },
  filters: {
    toTime: function (a) {
      if (!a) return '';
      let position = 2;
      var output = [a.slice(0, position), ':', a.slice(position)].join('');
      return output;
    },
  },
  // 'RECEIPT' | 'WAIT' | 'REAL' | 'RECEIPT_CANCEL' | 'WAIT_CANCEL' | 'REAL_CANCEL'
  computed: {
    getListType() {
      return getReservText(this.listType);
    },
  },

  data() {
    return {
      totalCount: 0,
    };
  },
  methods: {
    refreshTotalCount() {
      this.totalCount = 0;
      this.revConfirmList.forEach(x => {
        this.totalCount += x.teamCount;
      });
    },
    onItemClickDelete(o, i) {
      this.$EventBus.$emit('RemoveReceipt', o);
    },

    isCompany(o) {
      let user = this.$store.getters['Auth/selectedMember'];
      console.log('user', user, o);

      // 법인회원 코드 : 006
      return user.memType === '006';
    },
    getMaxCount(o) {
      let teamCount = 0;
      this.revConfirmList.forEach(x => {
        let flag1 = x.type === o.type;
        let flag2 = moment(x.selectedDate).format('YYYYMMDD') === moment(o.selectedDate).format('YYYYMMDD');
        let flag3 = x.selectedCourse.coseCd === o.selectedCourse.coseCd;
        let flag4 = x.selectedCourse.coseItem === o.selectedCourse.coseItem;
        let flag5 = x.selectedCourse.coseName === o.selectedCourse.coseName;

        if (flag1 && flag2 && flag3 && flag4 && flag5) {
          teamCount += x.teamCount;
        }
      });
      console.log('#####', o, o.teamLimitCount, o.teamReservCount, teamCount);

      let availableCount = o.teamLimitCount - o.teamReservCount - teamCount;
      return o.teamCount + availableCount;
    },
    getCourseHoleString(course) {
      switch (this.listType) {
        case 'RECEIPT':
          return '18';
        case 'WAIT':
          return '18';
        case 'REAL': {
          console.log('+++++++++++', this.revConfirmList, course);
          if (course === '001') {
            return '9';
          } else if (course === '002') {
            return '18';
          } else {
            return '';
          }
        }
        default:
          return '';
      }
    },
    getDateString(date) {
      return DateUtil.getYYYY_MM_DD_WEEK(date);
    },
    getCourseString(course) {
      let courseName = '';
      course.map(x => {
        if (courseName === '') {
          courseName += x.coseName;
        } else {
          courseName += `,${x.coseName}`;
        }
      });
      return courseName;
    },
  },
};
</script>

<style scoped lang="scss">
article div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 25px;
  transition: 0.5s ease;
}
th {
  border: 0;
}

//article input {
//  position: absolute;
//  top: 0;
//  left: 0;
//  width: 140px;
//  height: 50px;
//  opacity: 0;
//  cursor: pointer;
//}
//
//input[type='radio']:checked ~ div {
//  background-color: #50bcf2;
//}
.mobile4 {
  display: none;
}
.web4 {
  margin: 0;
  padding: 0;

  .col {
    font-size: 0.9rem;
  }

  .row {
    font-size: 0.9rem;
  }

  .outterBox {
    .topHeader {
      padding-top: 2rem;
      padding-left: 2rem;
      font-weight: bold;
      font-size: 1.3rem;
      .countText {
        font-size: 1rem;
      }
      .numText {
        font-size: 1.1rem;
      }
    }

    .top {
      display: flex;
      padding: 1rem;
    }

    .dateColumn {
      width: 100%;
      display: inline-block;
      //border: 2px solid grey;
      //height: 15rem;
      //overflow-y: scroll;
      //overflow-x: hidden;
    }

    .receiptItem {
      position: relative;
      width: 100%;
      display: flex;
      height: auto;
      float: left;
      border: 2px solid #9a9a9a;
      box-sizing: border-box;
      background-color: white;
      margin: 0.2rem;
      padding: 1rem;

      .receiptItemInner1 {
        //padding-top: 0.5rem;
        //padding-left: 0.5rem;
      }

      .receiptItemInner2 {
        //padding-top: 0rem;
        //padding-left: 0.5rem;
        //padding-bottom: 0.5rem;
      }
    }

    .deleteButton {
      display: inline-flex;
      align-items: center;
      height: 2.3rem;
      font-size: 0.8rem;
      width: 80%;
      background-color: transparent !important;
      padding: 0px !important;
      color: #ba4b30;
      border: 1px solid #e0e0e0;
      outline: none;

      span {
        padding: 0px;
        width: 100%;
        text-align: center;
        padding: 0px !important;
      }
    }

    .noItem {
      display: block;
      line-height: 5rem;
      min-height: 5rem;
      font-size: 0.9rem;
      text-align: center;
    }
  }
}

@media (max-width: 992px) {
  hr {
    margin: 0px;
  }
  .web4 {
    display: none;
  }
  .mobile4 {
    display: block;
    .col {
      font-size: 0.9rem;
    }

    .row {
      font-size: 0.9rem;
    }

    .outterBox {
      width: 100%;
      .topHeader {
        padding-top: 2rem;
        padding-left: 1rem;
        font-weight: bold;
        font-size: 1.3rem;

        .countText {
          font-size: 1rem;
        }
        .numText {
          margin-left: 1rem;
          font-size: 1.1rem;
        }
      }

      .top {
        display: flex;
        padding: 1rem;
      }

      .dateColumn {
        width: 100%;
        display: inline-block;
        //border: 2px solid grey;
        //height: 15rem;
        //overflow-y: scroll;
        //overflow-x: hidden;
      }
      .noItem {
        display: block;
        line-height: 5rem;
        min-height: 5rem;
        font-size: 0.9rem;
        text-align: center;
      }
    }
  }
  .deleteButton {
    display: inline-flex;
    align-items: center;
    height: 2.3rem;
    font-size: 0.8rem;
    width: 80%;
    background-color: transparent !important;
    padding: 0px !important;
    color: #ba4b30;
    border: none;
    outline: none;

    span {
      padding: 0px;
      width: 100%;
      text-align: center;
      padding: 0px !important;
    }
  }
  .itemStyle {
    width: 100%;
    line-height: 2rem;
    border: 1px solid #e0e0e0;
    margin-bottom: 0.5rem;
    .cHead {
      font-size: 0.9rem;
      font-weight: 600;
      //border-right: 1px solid red;
    }
    .cBody {
      font-size: 0.9rem;
    }
  }
  .spinStyle {
    height: 2rem;
  }
}
.rowSpace {
  height: 0.5rem;
}
</style>
